import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Jcktk { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '單號 (TK001) 不可空白'}) 
    @MaxLength(20,{message: '單號 (TK001) 資料太長'})
    TK001: string = '';            // 單號 20 ** 建檔時間 20220601-150245755

    @MaxLength(8,{message: '日期 (TK002) 資料太長'})
    TK002: string = '';            // 日期 8 

    @MaxLength(10,{message: '使用者 (TK003) 資料太長'})
    TK003: string = '';            // 使用者 10 

    @MaxLength(20,{message: '自訂分類 (TK005) 資料太長'})
    TK005: string = '';            // 自訂分類 20 

    TK006: string = '';            // 問題 0 

    TK007: string = '';            // 回答 0 

    @IsNumber() 
    TK008: number = 0;            // 問題token數 6 

    @IsNumber() 
    TK009: number = 0;            // 回答token數 6 


}
